import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';

class CustomerApprovalWithoutDocuments extends React.PureComponent {

    static propTypes = {
        id: PropTypes.string.isRequired,
        isValid: PropTypes.bool.isRequired
    };

    handleRedirect(e) {
        e.preventDefault();
        window.location = `https://www.amiattachments.com`;
    }

    render() {
        const { id, isValid } = this.props;
        return (
            <div>
                <h3 className="card-title text-center">DOCUMENT APPROVAL REQUEST</h3>
                {!isValid && <h5 className="text-center">We weren't able to find any documents that require approval for '{id}'.</h5>}
                {isValid && <h5 className="text-center">Oops! We couldn't find any documents that require approval on Order #{id}.</h5>}
                <h5 className="text-center">Please contact your Dealer for more information.</h5>
                <div className="row justify-content-center p-2">
                    <Button
                        type="button"
                        color="primary"
                        onClick={this.handleRedirect}
                        className="m-1 ms-3"
                    >
                        Exit Blackbird
                    </Button>
                </div>
            </div>
        );
    }
}

    export default withRouter(CustomerApprovalWithoutDocuments);